// extracted by mini-css-extract-plugin
module.exports = {"center":"AuthError_center_3aTxQ"};